import { render } from "./EmisionPlanServicio.vue?vue&type=template&id=23aaa9e5&scoped=true"
import script from "./EmisionPlanServicio.vue?vue&type=script&lang=js"
export * from "./EmisionPlanServicio.vue?vue&type=script&lang=js"

import "./EmisionPlanServicio.vue?vue&type=style&index=0&id=23aaa9e5&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23aaa9e5"]])

export default __exports__